// extracted by mini-css-extract-plugin
export default {"wrapBackText":"index_wrapBackText__1Toxr","smallText":"index_smallText__SGdkO","radioButtonsWrap":"index_radioButtonsWrap__C2Hj1","spaceItemRadio":"index_spaceItemRadio__E5dAY"};